import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Button, ButtonGroup } from '@pattern-library/buttons';
import TextInput from '@pattern-library/text-input';
import useUnifiedLoginFormValidation from '../../hooks/useUnifiedLoginFormValidation';

const propTypes = {
    antiForgeryToken: PropTypes.string.isRequired,
    buttonProps: PropTypes.objectOf(PropTypes.string).isRequired,
    code: PropTypes.string.isRequired,
    formAction: PropTypes.string.isRequired,
    securityQuestionProps: PropTypes.arrayOf(PropTypes.object).isRequired,
    username: PropTypes.string.isRequired,
    validation: PropTypes.arrayOf(PropTypes.object).isRequired
};

function SecurityQuestionsForm(props) {
    const {
        antiForgeryToken,
        buttonProps,
        code,
        formAction,
        securityQuestionProps,
        username,
        validation
    } = props;

    const fields = securityQuestionProps.map((question, i) => {
        const key = `UserSecurityAnswers_${i}`;

        return {
            key,
            question: {
                id: `${key}__pkUserSecurityQuestion`,
                name: `UserSecurityAnswers[${i}].pkUserSecurityQuestion`,
                value: question.pkUserSecurityQuestion
            },
            answer: {
                id: `${key}__AnswerText`,
                name: `UserSecurityAnswers[${i}].AnswerText`,
                label: question.QuestionText
            }
        };
    });

    const schema = Object.fromEntries(fields.map(field => [field.answer.name, validation]));

    const { hasError, onSubmit, errorMessage } = useUnifiedLoginFormValidation({ schema });

    return (
        <div className="ul-login-form">
            <form
                action={formAction}
                method="post"
                onSubmit={onSubmit}
                autoComplete="false"
                noValidate
            >
                <div dangerouslySetInnerHTML={{ __html: antiForgeryToken }} />
                <input type="hidden" id="Code" name="Code" value={code} />
                <input type="hidden" id="Username" name="Username" value={username} />
                {fields.map(({ key, question, answer }) => {
                    return (
                        <Fragment key={key}>
                            <input type="hidden" {...question} />
                            <TextInput
                                isRequired
                                autoComplete="off"
                                maxLength={255}
                                {...answer}
                                hasError={hasError(answer.name)}
                                errorMessage={errorMessage(answer.name)}
                            />
                        </Fragment>
                    );
                })}
                <ButtonGroup alignment="center" className="asc-mt-4 asc-mb-0">
                    <Button type="submit" className="asc-mtb-0" {...buttonProps} />
                </ButtonGroup>
            </form>
        </div>
    );
}

SecurityQuestionsForm.propTypes = propTypes;
export default SecurityQuestionsForm;
